import React from "react";
import { useNavigate } from "react-router-dom";

const alphaLive = [
  { label: "Think5Whys Certification", icon: "🌾", path: "/bookshelf" },
  { label: "Periodic Table", icon: "👨‍🌾", path: "/bookshelf" },
  { label: "Children Collection 1", icon: "🕊️", path: "/bookshelf" },
  { label: "Chronicle", icon: "📖", path: "/life-chronicles-home" },
  { label: "Applause", icon: "👏", path: "/applause-hub-home" },
  { label: "Book world", icon: "📚", path: "/bookworld" },
  { label: "RCA", icon: "🔍", path: "/fivewhys-analysis-home" },
  { label: "Profile", icon: "👤", path: "/my-Profile-home" },
  { label: "Wallet", icon: "👛", path: "/Wallet-home" },
  { label: "Orderflow", icon: "📦", path: "/Orderflow-home" },
];

const year1 = [
  { label: "Agrilink", icon: "🌾", path: "/Agrilink" },
  { label: "Ageless", icon: "🕊️", path: "/Ageless" },
  { label: "AICounselling", icon: "🗣️", path: "/aicounselling" },
  { label: "BlueHands", icon: "🫐", path: "/Bluehands-home" },
  { label: "Consultants", icon: "🧑‍💼", path: "/think5whys-consultants" },
  { label: "DigiBoutique", icon: "🧑‍💻", path: "/DigiBoutique" },
  { label: "GenZ", icon: "🐉", path: "/Genji" },
  { label: "Golden7", icon: "🏅", path: "/Golden7" },
  { label: "Grihani", icon: "🏡", path: "/grihani" },
  { label: "RIM", icon: "🧘‍♂️", path: "/rim" },
  { label: "LearnX", icon: "📚", path: "/LearnX" },
  { label: "LiteNShort", icon: "🗞️", path: "/litenshort" },
  { label: "MATRIKA", icon: "👩‍👧", path: "/Matrika" },
  { label: "MindSpark", icon: "⚡", path: "/MindSpark" },
  { label: "Moderntech", icon: "🧩", path: "/Moderntech" },
  { label: "PreSchool", icon: "🧒", path: "/thinkpreschool-card" },
  { label: "Rankings", icon: "🏆", path: "/Rankings" },
  { label: "SAKSHAM MSME", icon: "🏭", path: "/msme" },
  { label: "SAKHSHAMShram", icon: "🧰", path: "/sakshamshram" },
  { label: "SheEarns", icon: "🦋", path: "/sheearns"},
  { label: "Touchbook", icon: "🖋️", path: "/touchbook-home" },
  { label: "ExamUnion", icon: "🔬", path: "/examunion" },
  { label: "MealFlow24", icon: "🍽️", path: "/mealflow24" },

  // { label: "VanMitra", icon: "🌲", path: "/vanmitra"},
];

const abc = [
  { label: "A. SheEarns", icon: "🦋", path: "/sheearns"},
  { label: "B. Agrilink", icon: "🌾", path: "/Agrilink" },
  { label: "B. BlueHands", icon: "🫐", path: "/Bluehands-home" },
  { label: "B. GenZ", icon: "🐉", path: "/Genji" },
  { label: "B. Golden7", icon: "🏅", path: "/Golden7" },
  { label: "B. MATRIKA", icon: "👩‍👧", path: "/Matrika" },
  { label: "B. MindSpark", icon: "⚡", path: "/MindSpark" },
  { label: "B. Ageless", icon: "🕊️", path: "/Ageless" },
  { label: "C. SAKSHAM MSME", icon: "🏭", path: "/msme" },
];

const year2 = [
  { label: "AI - Aalu Daalo Sona Nikalo!", icon: "🥔✨", path: "" }, 
  { label: "AI - Agri Products Grading", icon: "🌾", path: "" }, 
  { label: "AI - Find My Jewellery", icon: "💎🔍", path: "" }, 
  { label: "AI - Fashion Digital Tryout", icon: "👗📸", path: "" }, 
  { label: "AI - Writing To Text", icon: "✍️➡️🧠", path: "" }, 

  { label: "Agrijobs", icon: "👨‍🌾", path: "/Agrijobs-home" },
  { label: "AuthorDesk", icon: "✍️", path: "/Authordesk-home" },
  { label: "Ashram", icon: "🪔", path: "/Ashram" },
  { label: "BachiDeal", icon: "🧸", path: "/BachiDeal" },
  { label: "BEAUTI", icon: "💅", path: "/Beauti" },
  { label: "BharatBrain", icon: "🧠", path: "/Bharatbrain" },
  { label: "BoloGrahak", icon: "🛒", path: "/Bolograhak" },
  { label: "BPMForce", icon: "⚙️", path: "/BPMforce-home" },
  { label: "BPMJobs", icon: "💼", path: "/BPMjobs-home" },
  { label: "BFSIWorld", icon: "🏦", path: "/bfsiforward" },
  { label: "Buzz2brain", icon: "🚀", path: "/Buzz2brain" },
  { label: "CAFE", icon: "☕", path: "/CAFE-home" },
  { label: "CANDOR", icon: "💬", path: "/Candor" },
  { label: "CarDream", icon: "🚗", path: "/cardream" },  
  { label: "Chitrabhumi", icon: "🎨", path: "/Chitrabhumi" },
  { label: "CoolEarth", icon: "🌍", path: "/CoolEarth-home" },
  { label: "COUTUR", icon: "👗", path: "/Coutur" },
  { label: "Counsellors", icon: "🗣️", path: "/think5whys-counsellors" },
  { label: "CyberWisdom", icon: "💻", path: "/cyberwisdom" },
  { label: "DeepthinkLab", icon: "🧠", path: "/Deepthinklab" },
  { label: "DictaBook", icon: "📖", path: "/Dictabook-home" },
  { label: "DOE", icon: "🏛️", path: "/DOE" },
  { label: "DSeven", icon: "🧩", path: "/dseven" },
  { label: "FinLiteracy", icon: "💰", path: "/Finliteracy" },
  { label: "FortyFivePlusJobs", icon: "🧓", path: "/fortyfivejobs-home" },
  { label: "Googly", icon: "🏏", path: "/googly" },
  { label: "GovZone", icon: "🏛️", path: "/GovZone-home" },
  { label: "Honeymoon Travel", icon: "💞", path: "/honeymoonlight" },
  { label: "HORECA", icon: "🍽", path: "/horecahub"},
  { label: "HugAFounder", icon: "🤝", path: "/HugAFounder" },
  { label: "IDLY", icon: "🥣", path: "/Idly" },
  { label: "IDoNothing", icon: "🧘‍♂️", path: "/Idonothing" },
  { label: "Institution", icon: "🏫", path: "/Anjumanislam" },
  { label: "JEE-NEEET", icon: "📘", path: "/jeeneetopenbook-home" },
  { label: "Jugaad", icon: "🧱", path: "/jugaad" },
  { label: "Kaizen", icon: "🔁", path: "/mykaizen-home" },
  { label: "LAST", icon: "🏁", path: "/Last-home" },
  { label: "Ledger", icon: "📒", path: "/Ledger" },
  { label: "Litti", icon: "🥙", path: "/Litti" },
  { label: "MADSMania", icon: "🎭", path: "/MADSMania-home" },
  { label: "MahaSheetal", icon: "💧", path: "/Mahasheetal" },
  { label: "Mathverse", icon: "➗", path: "/Mathverse" },
  { label: "MedicineFinder", icon: "💊", path: "/MedicineFinder" },
  { label: "MovieMania", icon: "🎞️", path: "/moviemania" },
  { label: "Nearbydeals", icon: "📍", path: "/Nearbydeals" },
  { label: "Noteflex", icon: "📝", path: "/Noteflex-home" },
  { label: "Odyssey", icon: "🌠", path: "/Odyssey-home" },
  { label: "Absconders & Defaulters", icon: "🚫", path: "/offboarded-home" },
  { label: "PacketPulse", icon: "📦", path: "/PacketPulse-home" },
  { label: "PurplePower", icon: "💜", path: "/PurplePower-home" },
  { label: "RANKR", icon: "📊", path: "/Rankr" },
  { label: "Remedy2", icon: "🩺", path: "/Remedy2" },
  { label: "Righttrak", icon: "🧭", path: "/Righttrak" },
  { label: "RISE", icon: "🌅", path: "/Rise" },
  { label: "Riskmatics", icon: "⚠️", path: "/Riskmatics-home" },
  { label: "RoomAnywhere", icon: "🏠", path: "/roomanywhere" },
  { label: "ROUTE", icon: "🛣️", path: "/Route" },
  { label: "SHEETAL", icon: "❄️", path: "/Sheetal" },
  { label: "ShubhVivah", icon: "💍", path: "/shubhvivah" },
  { label: "SkillGrill", icon: "🔥", path: "/Skillgrill" },
  { label: "SmartDrill", icon: "🛠️", path: "/smartdrill-home" },
  { label: "SpaceSentinel", icon: "🛰️", path: "/spacesentinel"},
  { label: "SpotSnap", icon: "📸", path: "/Spotsnap" },
  { label: "Startup", icon: "🚀", path: "/Startup" },
  { label: "SuperLiquid", icon: "⚗️", path: "/superliquid" },
  { label: "Teachable", icon: "🧑‍🏫", path: "/Teachable" },
  { label: "Testbook", icon: "📕", path: "/testbook-exams" },
  { label: "ThinkHealth", icon: "💓", path: "/think-health-home" },
  { label: "ThinkProperty", icon: "🏘️", path: "/thinkproperty" },
  { label: "ThinkRent", icon: "🏠", path: "/think-rent-home" },
  { label: "ThinkService", icon: "🛠️", path: "/think-service-home" },
  { label: "ThinkStylus", icon: "🖊️", path: "/thinkstylus" },
  { label: "ThinkTimetable", icon: "📆", path: "/think-timetable-home" },
  { label: "TVBook", icon: "📺", path: "/TVBook-home" },
  { label: "UnityDeals", icon: "🤝", path: "/Unitydeals" },
  { label: "Udyam", icon: "🏭", path: "/Udyam" },
  { label: "VisaX", icon: "🛫", path: "/visaapplication" },   
  { label: "VisiGift", icon: "🎁", path: "/Visigift-home" },
  { label: "VITAL-D", icon: "🩸", path: "/Vitald" },
  { label: "wTube", icon: "▶️", path: "/wtube" },  
];

const year3 = [
  { label: "AI - Plant Diseases", icon: "🪴🧬", path: "" }, 
  { label: "AI - Livestock Farming", icon: "🐄🤖", path: "" }, 
  { label: "AI - Early Learning Plate", icon: "🎓🧩", path: "" }, 
  { label: "AI - FinTrust", icon: "💹🛡️", path: "" }, 
  { label: "AI - Signature Recognition", icon: "🖋️🤖", path: "" }, 
  { label: "AI - Classroom Surveillance", icon: "🏫🎥", path: "" }, 
  { label: "AI - Traffic Surveillance", icon: "🚦📹", path: "" }, 
  { label: "AI - Garbage Surveillance", icon: "🗑️👁️", path: "" },

  { label: "CorpZone", icon: "🏢", path: "/CorpZone-home" },
  { label: "DroneOps", icon: "🛸", path: "/droneops" },
  { label: "FeetFirst", icon: "👣", path: "/Feetfirst" },
  { label: "BJPSHAALA", icon: "🏫", path: "/bjpshaala" },
  { label: "EducationJobs", icon: "🎓", path: "/educationjobs-home" },
  { label: "Exhibitors", icon: "🎪", path: "/exhibitors-home" },
  { label: "FarmCharm", icon: "🌻", path: "/Farmcharm" },
  { label: "FundLanes", icon: "💸", path: "/Fundlanes" },
  { label: "ISO360", icon: "📜", path: "/ISO360-home" },
  { label: "Janpath", icon: "🛍️", path: "/Janpath" },
  { label: "LensShop", icon: "👓", path: "/Lensshop" },
  { label: "Processifyd", icon: "🔧", path: "/Processifyd-home" },
  { label: "SanatanSchool", icon: "📚", path: "/Sanatanschool" },
  { label: "Scrappy", icon: "🧩", path: "/Scrappy" },
  { label: "SigmaStudio", icon: "🎥", path: "/SigmaStudio" },
  { label: "SportsJobs", icon: "🏅", path: "/sportsjob-home" },
  { label: "SprintCentral", icon: "🏃‍♀️", path: "/sprintcentral-home" },
  { label: "StreamingHub", icon: "📺", path: "/Streaminghub" },
  { label: "Tindi", icon: "🍛", path: "/Tindi" },
  { label: "Thinkletics", icon: "🏋️‍♀️", path: "/thinkleticsdashboard" },
  { label: "TwinGuard", icon: "🤖🛡️", path: "/TwinGuard" },
  { label: "TwiWorld", icon: "🤖🪞", path: "/Twiworld" },
  { label: "VISTAAR", icon: "🌏", path: "/Vistaar" },
  { label: "YUVASolver", icon: "🧑‍💻", path: "/Yuvasolver" },
];

const year45 = [
  { label: "AI - Neuro Scan", icon: "🧠🩺", path: "" }, 
  { label: "AI - Oral360", icon: "🦷🔬", path: "" }, 
];

const year610 = [
  { label: "AI - DNA Sequencing", icon: "🧬💻", path: "" }, 
];

const Roadmap = () => {
  const navigate = useNavigate();

  const renderCards = (items) =>
    items.map((item, index) => (
      <div
        key={index}
        onClick={() => navigate(item.path)}
        title={item.label}
        className="cursor-pointer flex flex-col items-center justify-center gap-2 p-4 bg-pink-50 hover:bg-pink-100 text-gray-800 rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 ease-in-out"
      >
        <span className="text-2xl">{item.icon}</span>
        <span className="font-semibold text-xs text-center">{index + 1}. {item.label}</span>
      </div>
    ));

  return (
    <div className="p-4 mx-auto font-sans">
      <div className="text-center mb-4">
        <h1 className="text-2xl font-bold text-yellow-200 mb-2">Think5Whys Roadmap</h1>
        <p className="text-white text-sm">
          🪜 Step By Step: Building Blocks of Transformation-as-a-Platform 
        </p>
      </div>

      <h2 className="text-lg font-bold mt-4 text-yellow-200">Alpha Live: Oct'2024</h2>
      <h2 className="text-xs font-bold mt-1 mb-3 text-white">Platfrom Testing, Stakeholders Outreach. Initial Demo. Initial Validations. Few Customers</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(alphaLive)}
      </div>

      <div className="bg-purple-600 rounded-lg py-4 px-4 mt-4">
        <h2 className="text-lg font-bold mb-2 text-yellow-200">Year 1 ABC (A: Big Bet, B - Side Sprints, C - Marathon)</h2>
        <h2 className="text-xs font-bold mt-1 mb-3 text-white">A mix of implementation. A. Big Bet (High Scope of virality), B. Side Sprints (As side runners), C. Marathon (Stabilising for Perpetuality. Initial Slow Mover).</h2>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
          {renderCards(abc)}
        </div>
      </div>

      <h2 className="text-lg font-bold mt-4 mb-3 text-yellow-200">Year 1: Content-Community-Commerce</h2>
      <h2 className="text-xs font-bold mt-1 mb-3 text-white">Alpha Module Relaunch. New Modules and Content Launch. Quick Wins focus for community building with revenue. Stakeholders Outreach. Initial Traction. Pilot. Platfrom Refinemenet. Multiple GTM eg C2C, B2C, B2B, B2B2C, G2C. 1 Crore Registration and 25 Lakh Subscriber Target. SAKSHAM MSME Initial Customer. Rev Target: Rs. 25 to 50 Crore.</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(year1)}
      </div>

      <h2 className="text-xl font-bold mt-4 mb-3 text-yellow-200">Year 2</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(year2)}
      </div>


      <h2 className="text-xl font-bold mt-4 mb-3 text-yellow-200">Year 3</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(year3)}
      </div>

      <h2 className="text-xl font-bold mt-4 mb-3 text-yellow-200">Year 4-5</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(year45)}
      </div>

      <h2 className="text-xl font-bold mt-4 mb-3 text-yellow-200">Year 6-10</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-3">
        {renderCards(year610)}
      </div>
    </div>
  );
};

export default Roadmap;

